import { useEffect, useState } from 'react';

import { useParams } from '@redwoodjs/router';
import { MetaTags, useQuery } from '@redwoodjs/web';

import AccessDenied from 'src/components/AccessDenied/AccessDenied';
import { StepperComponent } from 'src/components/StepperComponent/StepperComponent';
import { ADD_SERVICE_STEPS } from 'src/constants/addService';
import { ROLE_PERMISSIONS } from 'src/constants/role-permissions';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import { GET_MERCHANT } from 'src/graphql/queries/merchants.query';
import useHasPermission from 'src/hooks/useHasPermission';
import useServiceApplication from 'src/hooks/useServiceApplication';
import { PageContent } from 'src/layouts/MainLayout/PageContent';
const AddServicePage = () => {
    const { merchantId } = useParams();
    const {
        checkForDraftApplication,
        activeStep,
        setIsDraftApplicationId,
        setServiceApplication,
        merchantApplication,
        serviceApplication,
        setActiveStep,
    } = useAddMerchantContext();
    const [steps, setSteps] = useState(ADD_SERVICE_STEPS);

    const hasPermission = useHasPermission(ROLE_PERMISSIONS.addService);

    const { data: merchantData, loading: findingMerchant } = useQuery(GET_MERCHANT, {
        variables: { id: Number(merchantId) },
    });
    useEffect(() => {
        if (merchantData?.merchant?.applicationId) {
            setIsDraftApplicationId(Number(merchantData.merchant?.applicationId));
        }
    }, [merchantData, setIsDraftApplicationId]);

    useEffect(() => {
        if (!findingMerchant) checkForDraftApplication();
    }, [findingMerchant]);

    useServiceApplication(
        merchantApplication?.merchantAccountNumber || merchantData?.merchant?.merchantAccountNumber,
        serviceApplication,
        setActiveStep,
        setServiceApplication
    );
    useEffect(() => {
        window.scrollTo(0, 0);
        if (activeStep === 1) {
            setSteps((prevState) => {
                return prevState.map((step) => {
                    return { ...step, completed: true };
                });
            });
        }
    }, [activeStep]);

    if (!hasPermission) {
        return <AccessDenied permission={ROLE_PERMISSIONS.addService} />;
    }

    return (
        <PageContent>
            <MetaTags title="Add Service" description="Add Service" />
            <StepperComponent
                setActiveStep={() => {}}
                stepsList={steps}
                handleNext={() => {}}
                showStepLabel={false}
                activeStep={activeStep}
            />
            {steps?.[activeStep]?.form}
        </PageContent>
    );
};
export default AddServicePage;
